/**
 * `?returnTo=` handling for the account login flow. Only internal paths are
 * accepted: the value must start with "/" but not "//" (protocol-relative
 * URLs would allow an open redirect).
 */
export const sanitizeReturnTo = (raw: string | null): string | null => {
  if (!raw) return null;
  // "//host" is protocol-relative; "/\host" is treated the same way by
  // browsers — both would allow an open redirect via a location sink.
  if (!raw.startsWith("/") || raw.startsWith("//") || raw.startsWith("/\\")) {
    return null;
  }
  return raw;
};

/** Reads and sanitizes `returnTo` from a location search string. */
export const readReturnTo = (search: string): string | null =>
  sanitizeReturnTo(new URLSearchParams(search).get("returnTo"));

/** Appends a validated returnTo to a path (no-op when there is none). */
export const withReturnTo = (
  pathname: string,
  returnTo: string | null
): string =>
  returnTo ? `${pathname}?returnTo=${encodeURIComponent(returnTo)}` : pathname;
